module.exports = __webpack_public_path__ + "media/Images/icon-magnifying-glass-o-5d5bfda12f730bd9c510c13275b54bd3.svg";